/* Restwick (04.10.2026): Galerie, Bestandszaehler, Staffel-Kaufblock, Direkt-Checkout, Review-Filter. */
(function () {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function money(cents, cur, forceDec) {
    const v = cents / 100;
    const dec = forceDec || v % 1 !== 0 ? 2 : 0;
    try { return new Intl.NumberFormat('en-US', { style: 'currency', currency: cur || 'USD', minimumFractionDigits: dec, maximumFractionDigits: dec }).format(v); }
    catch (e) { return '$' + v.toFixed(dec); }
  }

  /* Galerie */
  $$('[data-rw-gal]').forEach(g => {
    const main = $('.rw-gal__main', g), strip = $('.rw-gal__thumbs', g), thumbs = $$('.rw-gal__thumbs button', g);
    let cur = 0;
    const go = i => main.scrollTo({ left: main.clientWidth * Math.max(0, Math.min(thumbs.length - 1, i)), behavior: 'smooth' });
    thumbs.forEach((b, i) => b.addEventListener('click', () => go(i)));
    /* Karussell (Gavin 06.10.): 4 Vorschaubilder sichtbar, Pfeile blaettern, aktives Bild bleibt im Blick */
    let prev, next;
    if (strip && thumbs.length > 4) {
      const wrap = document.createElement('div');
      wrap.className = 'rw-gal__strip';
      strip.parentNode.insertBefore(wrap, strip);
      prev = document.createElement('button'); prev.type = 'button'; prev.className = 'rw-gal__arr rw-gal__arr--l'; prev.setAttribute('aria-label', 'Previous image'); prev.innerHTML = '&#8249;';
      next = document.createElement('button'); next.type = 'button'; next.className = 'rw-gal__arr rw-gal__arr--r'; next.setAttribute('aria-label', 'Next image'); next.innerHTML = '&#8250;';
      wrap.append(prev, strip, next);
      prev.addEventListener('click', () => go(cur - 1));
      next.addEventListener('click', () => go(cur + 1));
    }
    const sync = () => {
      thumbs.forEach((b, j) => b.classList.toggle('is-on', cur === j));
      if (prev) { prev.disabled = cur === 0; next.disabled = cur === thumbs.length - 1; }
      const t = thumbs[cur];
      if (strip && t) {
        const l = t.offsetLeft - strip.offsetLeft, r = l + t.offsetWidth;
        if (l < strip.scrollLeft) strip.scrollTo({ left: l, behavior: 'smooth' });
        else if (r > strip.scrollLeft + strip.clientWidth) strip.scrollTo({ left: r - strip.clientWidth, behavior: 'smooth' });
      }
    };
    main.addEventListener('scroll', () => {
      const i = Math.round(main.scrollLeft / main.clientWidth);
      if (i !== cur) { cur = i; sync(); }
    }, { passive: true });
    sync();
  });

  /* Bestandszaehler wie Westlyn: Start 140 bis 160, faellt bis 9, Reset nach 1 Stunde */
  $$('[data-rw-stock]').forEach(el => {
    const KEY = 'rw_stock_state', num = $('[data-rw-stock-n]', el), bar = $('[data-rw-stock-bar]', el);
    let st;
    try { st = JSON.parse(localStorage.getItem(KEY) || 'null'); } catch (e) { st = null; }
    const now = Date.now();
    if (!st || now - st.t0 > 3600000) st = { t0: now, start: 140 + Math.floor(Math.random() * 21), n: 0 };
    if (!st.n) st.n = st.start;
    const save = () => { try { localStorage.setItem(KEY, JSON.stringify(st)); } catch (e) {} };
    const draw = () => { num.textContent = st.n; if (bar) bar.style.width = Math.max(8, Math.round(st.n / st.start * 48)) + '%'; };
    const tick = () => {
      if (st.n > 9) { st.n -= 1; save(); draw(); }
      const near = Math.max(0, Math.min(1, (st.start - st.n) / (st.start - 9)));
      setTimeout(tick, (10 + near * 100) * 1000 * (0.7 + Math.random() * 0.6));
    };
    draw(); save(); setTimeout(tick, 10000);
  });

  /* Lieferdatum: heute plus 8 Tage */
  $$('[data-rw-arrive]').forEach(el => {
    const d = new Date(Date.now() + 8 * 86400000);
    el.textContent = d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
  });

  /* Kaufblock */
  $$('[data-rw-buy]').forEach(box => {
    const cfg = JSON.parse($('[data-rw-cfg]', box).textContent);
    const tiers = $$('[data-rw-tier]', box), gifts = $$('[data-rw-gift]', box);
    const ups = $('[data-rw-ups]', box), upsQ = $$('[data-rw-ups-q]', box);
    const cta = $('[data-rw-cta]', box);
    let cur = tiers.find(t => t.classList.contains('is-on')) || tiers[0];

    tiers.forEach(t => {
      const qty = +t.dataset.qty, paid = +t.dataset.paid;
      const total = cfg.price * paid, compare = cfg.compare * qty;
      $('[data-rw-each]', t).textContent = money(Math.round(total / qty), cfg.currency) + ' ' + cfg.each;
      $('[data-rw-cmp]', t).textContent = money(compare, cfg.currency);
      $$('[data-rw-total]', t).forEach(e => e.textContent = money(total, cfg.currency));
      $$('[data-rw-saved]', t).forEach(e => e.textContent = money(compare - total, cfg.currency));
      t.addEventListener('click', () => select(t));
      t.addEventListener('keydown', e => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); select(t); } });
    });

    function select(t) {
      cur = t;
      tiers.forEach(x => { x.classList.toggle('is-on', x === t); x.setAttribute('aria-checked', x === t); });
      const lvl = tiers.indexOf(t) + 1;
      gifts.forEach(g => {
        const open = lvl >= +g.dataset.unlock;
        g.classList.toggle('is-locked', !open);
        $('[data-rw-gift-p]', g).hidden = !open;
        $('[data-rw-gift-lock]', g).hidden = open;
      });
      /* Gavin 07.10.: ab Stufe 2 steckt schon ein Gratis-Bezug im Paket (Geschenk-Variante), der Upsell gilt nur fuer
         die restlichen Kissen: 2+1 = x2, 3+2 = x4. Die Kasse legt das genauso an (siehe CTA unten), hier nur die Anzeige. */
      const upsN = (cfg.variantWith && cfg.variantGift && lvl >= 2) ? +t.dataset.qty - 1 : +t.dataset.qty;
      upsQ.forEach(e => e.textContent = upsN);
      if (ups) $('[data-rw-ups-price]', box).textContent = '+' + money((cfg.coverDelta != null ? cfg.coverDelta * +t.dataset.paid : cfg.upsPrice * +t.dataset.qty), cfg.currency);
      const uc = $('[data-rw-ups-cmp]', box); if (uc) uc.textContent = cfg.upsCompare ? money(cfg.upsCompare * upsN, cfg.currency) : '';
    }
    select(cur);

    cta.addEventListener('click', async () => {
      cta.disabled = true;
      const qty = +cur.dataset.qty, lvl = tiers.indexOf(cur) + 1, withCover = !!(ups && ups.checked);
      let items;
      if (cfg.variantWith) {
        /* Lieferant fuehrt nur Kissen ohne/mit Bezug (Gavin 04.10.): nie einen einzelnen Bezug in die Kasse.
           Ab Stufe 2 ist ein Kissen die Geschenk-Variante (mit Bezug, Preis wie ohne). */
        const main = withCover ? cfg.variantWith : cfg.variant;
        items = [];
        if (lvl >= 2 && cfg.variantGift) { items.push({ id: cfg.variantGift, quantity: 1 }); if (qty > 1) items.push({ id: main, quantity: qty - 1 }); }
        else items.push({ id: main, quantity: qty });
      } else {
        items = [{ id: cfg.variant, quantity: qty }];
        if (withCover && cfg.upsVariant) items.push({ id: cfg.upsVariant, quantity: qty });
      }
      (cfg.gifts || []).forEach(g => { if (g.variant && lvl >= g.unlock && !(cfg.variantWith && g.cover)) items.push({ id: g.variant, quantity: 1 }); });
      /* Direkter Kassen-Link (Cart-Permalink): nimmt die Artikel domainunabhaengig mit. Vorher landete die
         Vorschau auf myshopify.com mit leerem Warenkorb auf der Hauptdomain (Gavin 04.10.). */
      const merged = {};
      items.forEach(it => { merged[it.id] = (merged[it.id] || 0) + it.quantity; });
      const path = Object.keys(merged).map(id => id + ':' + merged[id]).join(',');
      /* Gavin 06.10.: erst Warenkorb, dann Side-Drawer, nicht direkt in die Kasse (SBC: ATC-Drawer als Website-Hebel).
         Faellt der Drawer aus, bleibt der alte Kassen-Link als Rueckfall, damit kein Kauf verloren geht. */
      try {
        const drawer = document.querySelector('cart-drawer');
        await fetch(root + 'cart/clear.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' } });
        const body = { items: Object.keys(merged).map(id => ({ id: +id, quantity: merged[id] })) };
        if (drawer && drawer.getSectionsToRender) { body.sections = drawer.getSectionsToRender().map(s => s.id); body.sections_url = window.location.pathname; }
        const r = await fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) });
        const data = await r.json();
        if (!r.ok || data.status) throw new Error(data.description || 'add failed');
        if (drawer && data.sections && drawer.renderContents) {
          /* Dawn: leerer Drawer traegt is-empty und blendet die Zeilen aus, product-form.js nimmt die Klasse vorher weg (Fix 06.10., Gavin-Go) */
          drawer.classList.remove('is-empty');
          drawer.renderContents(data); cta.disabled = false;
        }
        else window.location.href = root + 'cart';
      } catch (err) {
        window.location.href = root + 'cart/' + path;
      }
    });

    window.addEventListener('pageshow', () => { cta.disabled = false; });

    /* Mobile Sticky-Leiste */
    const sticky = $('[data-rw-sticky]');
    if (sticky && 'IntersectionObserver' in window) {
      new IntersectionObserver(es => es.forEach(e => sticky.classList.toggle('is-on', !e.isIntersecting && e.boundingClientRect.top < 0)))
        .observe(cta);
    }
  });

  /* "Select Bundle"-Knoepfe springen zum Kaufblock */
  document.addEventListener('click', e => {
    const b = e.target.closest('[data-rw-tobuy]');
    if (!b) return;
    const box = $('[data-rw-buy]');
    if (!box) return;
    e.preventDefault();
    box.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  /* Review-Filter */
  $$('[data-rw-reviews]').forEach(sec => {
    const chips = $$('[data-rw-chip]', sec), rvs = $$('[data-rw-cat]', sec);
    chips.forEach(c => c.addEventListener('click', () => {
      chips.forEach(x => x.classList.toggle('is-on', x === c));
      const f = c.dataset.rwChip;
      rvs.forEach(r => r.hidden = !(f === 'All' || r.dataset.rwCat === f));
    }));
  });

  /* FB-Posts: "See more" */
  $$('[data-rw-more]').forEach(b => b.addEventListener('click', () => {
    b.previousElementSibling.classList.remove('is-clamped');
    b.remove();
  }));

  /* Tracking-Formular: Sendungsnummer an den Paketdienst-Tracker */
  $$('[data-rw-track]').forEach(f => f.addEventListener('submit', e => {
    e.preventDefault();
    const n = (new FormData(f).get('n') || '').toString().trim().replace(/\s+/g, '');
    if (n) window.open('https://t.17track.net/en#nums=' + encodeURIComponent(n), '_blank', 'noopener');
  }));
})();
